import { Reveal } from "./Reveal";

export const ContentGallery = ({ contents = [], onOpen }) => (
  <section
    id="galeri"
    className="relative bg-[#050505] py-24 md:py-36 px-6 md:px-12 lg:px-24"
    data-testid="trust-gallery"
  >
    <Reveal className="max-w-3xl mb-14 md:mb-20">
      <span className="font-mono text-xs tracking-[0.3em] text-[#C48A5E] uppercase">
        03 — Güven Arşivi
      </span>
      <h2 className="mt-5 font-serif text-4xl md:text-6xl text-[#F5F5F0]">
        Her kare, bir <span className="italic text-[#C48A5E]">stratejik karar.</span>
      </h2>
      <p className="mt-6 font-sans text-base md:text-lg leading-relaxed text-[#A3A09A]">
        Her içeriğin arkasında bir amaç, bir duygu ve bir davranış hedefi vardır.
        İncelemek için bir içeriğe dokunun.
      </p>
    </Reveal>

    <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
      {contents.map((c, i) => (
        <Reveal key={c.slug} delay={(i % 3) * 0.05} className="mb-5 break-inside-avoid">
          <button
            onClick={() => onOpen(c)}
            data-testid={`trust-gallery-item-${c.idx}`}
            className="group relative block w-full overflow-hidden rounded-lg bg-[#0F0F0F] text-left"
          >
            <img
              src={c.media}
              alt={c.title}
              loading="lazy"
              className="w-full h-auto object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/25 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="absolute inset-x-0 bottom-0 p-5 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
              <div className="flex flex-wrap gap-1.5 mb-2">
                {(c.tags || []).slice(0, 2).map((t) => (
                  <span key={t} className="trust-pill">
                    {t}
                  </span>
                ))}
              </div>
              <div className="font-serif text-xl text-[#F5F5F0] leading-tight">{c.title}</div>
              <div className="mt-2 font-mono text-[10px] tracking-[0.2em] text-[#C48A5E] uppercase">
                Analizi Gör →
              </div>
            </div>
          </button>
        </Reveal>
      ))}
    </div>
  </section>
);

export default ContentGallery;
